export default {"src":"/_next/static/media/linkedin.16272e97.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};